/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.controller('dialog_editImageCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
        $scope.gui = {};
        $scope.gui.okButtonDisabled = true;
        $scope.event = {};
        $scope.datetTimePattern = //;
        
        $scope.hasValue = function(model){
            return model != undefined && model != "";
        }
        $scope.formChanged = function(){
            if($scope.hasValue($scope.event.Veranstaltungsname) && $scope.hasValue($scope.event.Startzeit) && $scope.hasValue($scope.event.Endzeit) && $scope.hasValue($scope.event.Veranstaltungsort)){
                $scope.gui.okButtonDisabled = false;
            }
        }
        
        $scope.myImage='';
        $scope.myCroppedImage='';

        var handleFileSelect=function(evt) {
          var file=evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function($scope){
              $scope.myImage=evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };
        angular.element(document.querySelector('#eventImg')).on('change',handleFileSelect);
        
        $rootScope.$on("editImageDialog", function(e, data){
            $scope.dataTarget = data.dataTarget
        })
        
        $scope.saveImage = function(){
            $rootScope.$emit("imageCropped", {img: $scope.myCroppedImage, dataTarget: $scope.dataTarget})
        }
    }])